// Whole-day difference between two `YYYY-MM-DD` logical dates (ADR 024 — Time
// Model). BL-2035: the invoice page's age and due labels count calendar days.
import { parseLogicalDate } from './parse-logical-date';

/**
 * Epoch day number of a logical date, read through the UTC lens as a pure
 * calendar oracle, so a DST change between two dates can never add or drop an
 * hour and round to the wrong day.
 */
function epochDay(logicalDate: string): number {
    const parts = parseLogicalDate(logicalDate);
    if (!parts) throw new Error(`diffLogicalDays: malformed logical date "${logicalDate}"`);
    return Date.UTC(parts.year, parts.month - 1, parts.day) / 86_400_000;
}

/**
 * Whole calendar days from `from` to `to`: positive when `to` is later.
 *
 * @param from - a `YYYY-MM-DD` logical date.
 * @param to - a `YYYY-MM-DD` logical date.
 * @returns `to − from` in days.
 * @throws when either input is not a real calendar day.
 */
export function diffLogicalDays(from: string, to: string): number {
    return epochDay(to) - epochDay(from);
}
